module.exports = __webpack_public_path__ + "img/icon-arrow-left-inactive.3897537b.svg";